import { defineStore } from 'pinia'
import { AuthState, createInitialState } from './authState'
import { AuthGetters, createGetters } from './authGetters'
import { AuthActions, createActions } from './authActions'

export type useAuthStoreResponse = AuthState & AuthGetters & AuthActions

export const useAuthStore = defineStore('auth', (): useAuthStoreResponse => {
  const state = createInitialState()
  const getters = createGetters(state)
  const actions = createActions(state, getters)

  return {
    ...state,
    ...getters,
    ...actions
  }
})
